import { layoutMenu, dashboardMenu, demoPages } from '../menu';

function collectPaths(obj, acc = []) {
	if (!obj || typeof obj !== 'object') return acc;
	for (const val of Object.values(obj)) {
		if (!val) continue;
		if (typeof val === 'object') {
			if (typeof val.path === 'string' && val.path) acc.push(val.path);
			collectPaths(val, acc);
		}
	}
	return acc;
}

const allPaths = collectPaths({ layoutMenu, dashboardMenu, demoPages });
const baseRouteSegments = new Set(
	allPaths
		.filter((p) => typeof p === 'string')
		.filter((p) => !p.startsWith('#') && !/^https?:\/\//i.test(p))
		.map((p) => p.replace(/^\/+/, ''))
		.filter((p) => p.length > 0)
		.map((p) => p.split('/')[0]),
);

export function getClientSlugFromLocation(loc = window.location) {
	const parts = (loc.pathname || '/').split('/').filter(Boolean);

	if (parts.length >= 2) {
		if (baseRouteSegments.has(parts[1])) {
			return parts[0] || null;
		}
		if (baseRouteSegments.has(parts[0])) return null;
	}

	if (parts.length === 1) {
		const seg = parts[0];
		if (!baseRouteSegments.has(seg)) return seg;
	}
	return null;
}

export function getClientSlug() {
	try {
		const slug = getClientSlugFromLocation();
		if (slug) {
			window.__CLIENT_SLUG__ = slug;
		}
		return slug;
	} catch (_) {
		return null;
	}
}

export default getClientSlug;
